function getMapElement<K, V>(map: Map<K, V>, key: K): V {
  const element = map.get(key);

  if (element === undefined) {
    throw new Error(`Element with key ${key} not found in map`);
  }

  return element;
}

export { getMapElement };
